'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _dec, _class, _class2, _temp;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactRedux = require('react-redux');

var _reactRouterRedux = require('react-router-redux');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var LoginSuccess = (_dec = (0, _reactRedux.connect)(function (state) {
  return { user: state.auth.user };
}), _dec(_class = (_temp = _class2 = function (_Component) {
  (0, _inherits3.default)(LoginSuccess, _Component);

  function LoginSuccess() {
    (0, _classCallCheck3.default)(this, LoginSuccess);
    return (0, _possibleConstructorReturn3.default)(this, (0, _getPrototypeOf2.default)(LoginSuccess).apply(this, arguments));
  }

  (0, _createClass3.default)(LoginSuccess, [{
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(newProps) {
      if (newProps.user && newProps.user.id) {
        var location = this.props.location;

        if (location && location.query && location.query.from) {
          console.log(location.query.from);
          newProps.dispatch((0, _reactRouterRedux.push)(location.query.from));
        } else {
          newProps.dispatch((0, _reactRouterRedux.push)('/@' + newProps.user.username));
        }
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var user = this.props.user;

      return _react2.default.createElement(
        'div',
        { className: 'container' },
        _react2.default.createElement(
          'h1',
          null,
          'Login Success'
        )
      );
    }
  }]);
  return LoginSuccess;
}(_react.Component), _class2.propTypes = {
  user: _react.PropTypes.object
}, _temp)) || _class);
exports.default = LoginSuccess;
module.exports = exports['default'];


/*****************
 ** WEBPACK FOOTER
 ** ./src/containers/LoginSuccess/LoginSuccess.js
 ** module id = 1111
 ** module chunks = 0
 **/